import { clearLocalStorage } from '@/utils/localstorage'
import { getRealmId, isOrgFlowRealm, ORG_FLOW_REALM_ID } from '@/utils/realmId'

export function getOidcConfiguration(): any {
  const idpHint = getIdpHint()
  const realmId = getRealmId() ?? 'zdb'
  const realmUrl = globalThis.appConfig.VITE_KEYCLOAK_URL + '/auth/realms/' + realmId
  const sendIdpHint = import.meta.env.VITE_OIDC_IDP_HINT_SEND !== 'false'
  return {
    settings: {
      authority: realmUrl,
      automaticSilentRenew: true,
      automaticSilentSignin: true,
      // The digitalbuildings realm authenticates through a dedicated Keycloak
      // client ("ui-frontend") separate from the per-customer realms' "frontend".
      client_id: isOrgFlowRealm(realmId) ? 'ui-frontend' : 'frontend',
      // Must match the post_logout_redirect_uri auth.ts's signoutRedirect() actually sends
      // (`/realm`, the post-logout landing page) — a mismatch here vs. what's registered as a
      // valid redirect URI on the Keycloak client can cause logout to fail to complete cleanly.
      postLogoutRedirectUri: globalThis.location.origin + '/realm',
      redirect_uri: globalThis.location.origin + `/oauth2`,
      responseType: 'code',
      scope: 'openid roles',
      silentRedirectUri: globalThis.location.origin + '/silentrenew',
      extraQueryParams: sendIdpHint
        ? {
            kc_idp_hint: idpHint
          }
        : undefined
    },
    optionalSettings: {},
    optionalEvents: {
      accessTokenExpired: () => {
        console.log('Access token expired, signing out')
        clearLocalStorage()
        globalThis.location.replace(globalThis.location.origin + `/oauth2`)
      }
    }
  }
}

function getIdpHint(): string | undefined {
  const internalZynkaUser = localStorage.getItem('internalZynkaUser')
  return internalZynkaUser ? 'digital-buildings' : undefined
}

// The exact hosts (per environment) that authenticate against the shared
// digitalbuildings realm rather than a per-customer one. Confirmed with Petter
// (ZDB-7082): everything else falls through to the {realm}.digitalbuildings.ai
// parsing below, unchanged.
const ORG_FLOW_HOSTS = new Set([
  'digitalbuildings.ai',
  'dev.digitalbuildings.ai',
  'staging.digitalbuildings.ai'
])

export function getRealmFromSubDomain(): string | null {
  const host = globalThis.location.host

  if (ORG_FLOW_HOSTS.has(host)) return ORG_FLOW_REALM_ID

  if (host.endsWith('digitalbuildings.ai') && host.startsWith('dev.')) {
    return host.split('.')[1]
  } else if (host.endsWith('digitalbuildings.ai')) return host.split('.')[0]

  return null
}
